import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Outlet, Navigate } from 'react-router-dom';

import AuthUtility from './components/frontend/auth/AuthUtility';

const UserPublicRoutes = () => {
	const location = useLocation();
	
    let auth = {'token':false, 'role':'none'};
	let nav_path = '';

    if(AuthUtility.isLoggedIn() && (location.pathname === '/login' || location.pathname === '/register')){
		
		auth.token = true;
		
		if(localStorage.getItem('auth_role') === 'user'){
			auth.role = 'user';
		}else if(localStorage.getItem('auth_role') === 'member'){
			auth.role = 'member';
		}else if(localStorage.getItem('auth_role') === 'admin'){
			auth.role = 'admin';
		}
		
		if(auth.role !== 'none' && (location.pathname === '/login' || location.pathname === '/register')){
			if(localStorage.getItem('auth_role') === 'user'){
				nav_path = '/user/account';
			}else if(localStorage.getItem('auth_role') === 'member'){
				nav_path = '/member/account';
			}else if(localStorage.getItem('auth_role') === 'admin'){
				nav_path = '/admin/account';
			}
		}else{
			nav_path = location.pathname;
		}
		
	}else if(location.pathname === '/'){
		nav_path = '/home';
	}else{
		nav_path = location.pathname;
	}
		
    return(
        location.pathname !== '/' && nav_path !== '/user/account' && nav_path !== '/member/account'
		&& nav_path !== '/admin/account' ? <Outlet/> : <Navigate to={nav_path}/>
    )
}

export default UserPublicRoutes